export default class Metadata {
  public skillItemIds:number[];
  public explanation:string;

  constructor (explanation:string = "", skillItemIds:number[] = []) {
    this.skillItemIds = skillItemIds;
    this.explanation = explanation;
  }

  public get toParams() {
    return { explanation: this.explanation, skill_item_ids: this.skillItemIds }
  }
}
